module.exports = __webpack_public_path__ + "img/using_help_check.0bd16f04.svg";